import { createContext } from "react";

import type { AuthUser } from "./auth";

export interface AuthContextValue {
  user: AuthUser;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
